import ToggleSwitch from './ToggleSwitch';

module.exports = ToggleSwitch;



// WEBPACK FOOTER //
// ./src/index.js